import { useDispatch } from "react-redux";
import { routes } from "../../assets/constants";
import { ApiMethod } from "../models/api-types.type";
import { buildQueryParams } from "../utils/utils";
import { useAuthContext } from "./use-auth-context.hook";
import { User } from "../models/user.model";

export const useVendorsApi = () => {
    const { sendAuthGuardedRequest } = useAuthContext();

    const findAllVendors = async (
        page?: number,
        limit?: number,
        search?: string,
        kind: 'customer' | 'prospect' = 'customer',
      ): Promise<any> => {
        const queryParams = [];
        
        if (kind === 'prospect') queryParams.push({ key: "kind", value: 'prospect' });
        if (page) queryParams.push({ key: "page", value: page.toString() });
        if (limit) queryParams.push({ key: "limit", value: limit.toString() });
        if (search) queryParams.push({ key: "searchValue", value: search });
        
        const queryString = buildQueryParams(queryParams);
    
        const response: any = await sendAuthGuardedRequest(
          ApiMethod.GET,
          routes.vendors.findAll + queryString,
        )
        return response
    };

    const findOneVendor = async (id): Promise<any> => {
      return await sendAuthGuardedRequest(
        ApiMethod.GET, 
        routes.vendors.findOne(id),
      )
  };

  const findVendorAreas = async (): Promise<any> => {
    return await sendAuthGuardedRequest(
      ApiMethod.GET,
      routes.vendors.findAreas,
    )
  };

  const findVendorAdminStats = async (): Promise<{ total: number; active: number; inactive: number }> => {
    const response: any = await sendAuthGuardedRequest(
      ApiMethod.GET,
      routes.vendors.adminStats,
    )
    return response
  };

    const findOneVendorAndDelete = async (id: string): Promise<any> => {
        await sendAuthGuardedRequest(
          ApiMethod.DELETE, 
          routes.vendors.deleteOne(id)
        )
    };

    const createVendor = async (vendor): Promise<any> => {
      if(vendor.spaces){
        //@ts-ignore
        vendor.spaces = vendor.spaces.map(space => space._id)
      }
      return await sendAuthGuardedRequest(
        ApiMethod.POST, 
        routes.vendors.create,
        vendor
      )
    }; 

    const updateVendor = async (id, vendor): Promise<any> => {
      if(vendor.spaces){
        //@ts-ignore
        vendor.spaces = vendor.spaces.map(space => space._id)
      }
      return await sendAuthGuardedRequest(
        ApiMethod.PATCH, 
        routes.vendors.patch(id),
        vendor
      )
    }; 
    
    /** A prospect (a vendor made for a demo) signed: it becomes a customer, catalogue and settings kept. */
    const convertProspect = async (id: string): Promise<any> => {
      return await sendAuthGuardedRequest(ApiMethod.POST, routes.vendors.convert(id));
    };

    /** The reverse: a vendor that is really a demo moves to the prospects, catalogue and settings kept. */
    const moveToProspects = async (id: string): Promise<any> => {
      return await sendAuthGuardedRequest(ApiMethod.POST, routes.vendors.toProspect(id));
    };

    /**
     * Turn a vendor's native AR files on or off. Only a super admin can: the copies it
     * makes are public, plain versions of models the catalogue keeps encrypted.
     */
    const setArPublicFiles = async (id: string, enabled: boolean): Promise<any> => {
      return await sendAuthGuardedRequest(ApiMethod.PATCH, routes.vendors.arPublicFiles(id), { enabled });
    };

    return {
      setArPublicFiles,
      convertProspect,
      moveToProspects,
      findAllVendors,
      findOneVendor,
      findOneVendorAndDelete,
      createVendor,
      updateVendor,
      findVendorAreas,
      findVendorAdminStats
    };

};
  